const numeral = require("numeral");
function format(num, formatStr) {
  try {
    let result = numeral(num).format(formatStr);
    return result;
  } catch (ex) {
    dsf.error(ex);
    return num;
  }
}
export default {
  format
};
